import { useState } from "react";

interface Props {
  value: number; // 0..5
  onChange?: (v: number) => void;
  size?: number;
  readOnly?: boolean;
  showCount?: number | null;
}

export function StarRating({ value, onChange, size = 22, readOnly, showCount }: Props) {
  const [hover, setHover] = useState<number | null>(null);
  const display = hover ?? value;

  return (
    <div className="inline-flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(display);
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onMouseEnter={readOnly ? undefined : () => setHover(n)}
            onMouseLeave={readOnly ? undefined : () => setHover(null)}
            onClick={readOnly ? undefined : () => onChange?.(n)}
            className={[
              "transition-transform duration-150",
              readOnly ? "cursor-default" : "cursor-pointer hover:scale-110",
            ].join(" ")}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
          >
            <Star size={size} filled={filled} />
          </button>
        );
      })}
      {showCount != null ? (
        <span className="ml-1 text-xs text-plum-mute">
          {value > 0 ? `${value.toFixed(1)} · ${showCount}` : `${showCount}`}
        </span>
      ) : null}
    </div>
  );
}

function Star({ size, filled }: { size: number; filled: boolean }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? "url(#starGrad)" : "none"} stroke={filled ? "transparent" : "#C9A961"} strokeWidth="1.4">
      <defs>
        <linearGradient id="starGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#E8B4B8" />
          <stop offset="60%" stopColor="#C77B85" />
          <stop offset="100%" stopColor="#C9A961" />
        </linearGradient>
      </defs>
      <path d="M12 2.5l2.94 6.6L22 10.2l-5.3 4.7 1.6 7.1L12 18.4l-6.3 3.6 1.6-7.1L2 10.2l7.06-1.1L12 2.5z" />
    </svg>
  );
}
